import React from 'react';
import styled from 'styled-components';
import CouponActiveTable from '../Table/CouponActiveTable';
type ICouponTabProps = {};
const CouponActiveTab: React.FC<ICouponTabProps> = () => {
  return (
    <CouponTabStyled>
      <CouponActiveTable />
    </CouponTabStyled>
  );
};

export default CouponActiveTab;
const CouponTabStyled = styled.div``;
